import { defineComponent as H, ref as p, computed as T, watch as J, nextTick as Q, openBlock as v, createElementBlock as D, normalizeClass as V, unref as w, createElementVNode as U, Fragment as Y, renderList as M, withKeys as N, withModifiers as A, createVNode as W } from "vue";
import f from "./index592.js";
import { basicYearTableProps as X } from "./index937.js";
import { getValidDateOfYear as Z } from "./index862.js";
import ee from "./index938.js";
import { useNamespace as ae } from "./index559.js";
import { useLocale as te } from "./index597.js";
import { castArray as b } from "./index765.js";
import { hasClass as E } from "./index641.js";
import { rangeArr as re } from "./index578.js";
const se = ["aria-label"], ne = ["aria-selected", "aria-label", "tabindex", "onKeydown"];
var De = /* @__PURE__ */ H({
  __name: "basic-year-table",
  props: X,
  emits: ["changerange", "pick", "select"],
  setup(I, { expose: j, emit: B }) {
    const K = (a, t) => {
      const r = f(String(a)).locale(t).startOf("year"), n = r.endOf("year").dayOfYear();
      return re(n).map((o) => r.add(o, "day").toDate());
    }, e = I, d = B, P = ae("year-table"), { t: L, lang: g } = te(), C = p(), x = p(), S = T(() => Math.floor(e.date.year() / 10) * 10), $ = p([[], [], []]), O = p(), h = p(), R = T(() => {
      var a, t, r;
      const l = $.value, n = f().locale(g.value).startOf("year");
      for (let o = 0; o < 3; o++) {
        const c = l[o];
        for (let m = 0; m < 4 && !(o * 4 + m >= 10); m++) {
          let s = c[m];
          s || (s = {
            row: o,
            column: m,
            type: "normal",
            inRange: !1,
            start: !1,
            end: !1,
            text: -1,
            disabled: !1,
            isSelected: !1,
            customClass: void 0,
            date: void 0,
            dayjs: void 0,
            isCurrent: void 0,
            selected: void 0,
            renderText: void 0,
            timestamp: void 0
          }), s.type = "normal";
          const y = o * 4 + m + S.value, i = f().year(y), u = e.rangeState.endDate || e.maxDate || e.rangeState.selecting && e.minDate || null;
          s.inRange = !!(e.minDate && i.isSameOrAfter(e.minDate, "year") && u && i.isSameOrBefore(u, "year")) || !!(e.minDate && i.isSameOrBefore(e.minDate, "year") && u && i.isSameOrAfter(u, "year")), (a = e.minDate) != null && a.isSameOrAfter(u) ? (s.start = !!(u && i.isSame(u, "year")), s.end = !!(e.minDate && i.isSame(e.minDate, "year"))) : (s.start = !!(e.minDate && i.isSame(e.minDate, "year")), s.end = !!(u && i.isSame(u, "year"))), n.isSame(i) && (s.type = "today"), s.text = y;
          const k = i.toDate();
          s.disabled = ((t = e.disabledDate) == null ? void 0 : t.call(e, k)) || !1, s.date = k, s.customClass = (r = e.cellClassName) == null ? void 0 : r.call(e, k), s.dayjs = i, s.timestamp = i.valueOf(), s.isSelected = q(s), c[m] = s;
        }
      }
      return l;
    }), z = () => {
      var a;
      (a = x.value) == null || a.focus();
    }, F = (a) => {
      const t = {}, r = f().locale(g.value), l = a.text;
      return t.disabled = e.disabled || (e.disabledDate ? K(l, g.value).every(e.disabledDate) : !1), t.today = r.year() === l, t.current = b(e.parsedValue).some((n) => n.year() === l), a.customClass && (t[a.customClass] = !0), a.inRange && (t["in-range"] = !0, a.start && (t["start-date"] = !0), a.end && (t["end-date"] = !0)), t;
    }, q = (a) => {
      const t = a.text;
      return b(e.date).some((r) => r.year() === t);
    }, _ = (a) => {
      var t;
      if (e.disabled) return;
      const r = (t = a.target) == null ? void 0 : t.closest(
        "td"
      );
      if (!r || !r.textContent || E(r, "disabled")) return;
      const l = r.cellIndex, o = r.parentNode.rowIndex * 4 + l + S.value, c = f().year(o);
      if (e.selectionMode === "range")
        e.rangeState.selecting ? (e.minDate && c >= e.minDate ? d("pick", { minDate: e.minDate, maxDate: c }) : d("pick", { minDate: c, maxDate: e.minDate }), d("select", !1)) : (d("pick", { minDate: c, maxDate: null }), d("select", !0));
      else if (e.selectionMode === "years") {
        if (a.type === "keydown") {
          d("pick", b(e.parsedValue), !1);
          return;
        }
        const m = Z(
          c.startOf("year"),
          g.value,
          e.disabledDate
        ), s = E(r, "current") ? b(e.parsedValue).filter((y) => y?.year() !== o) : b(e.parsedValue).concat([m]);
        d("pick", s);
      } else
        d("pick", o);
    }, G = (a) => {
      var t;
      if (!e.rangeState.selecting) return;
      const r = (t = a.target) == null ? void 0 : t.closest(
        "td"
      );
      if (!r) return;
      const l = r.parentNode.rowIndex, n = r.cellIndex;
      R.value[l][n].disabled || (l !== O.value || n !== h.value) && (O.value = l, h.value = n, d("changerange", {
        selecting: !0,
        endDate: f().year(S.value).add(l * 4 + n, "year")
      }));
    };
    return J(
      () => e.date,
      async () => {
        var a, t;
        (a = C.value) != null && a.contains(document.activeElement) && (await Q(), (t = x.value) == null || t.focus());
      }
    ), j({
      /**
       * @description focus on the current cell
       */
      focus: z
    }), (a, t) => (v(), D("table", {
      role: "grid",
      "aria-label": w(L)("el.datepicker.yearTablePrompt"),
      class: V(w(P).b()),
      onClick: _,
      onMousemove: G
    }, [
      U(
        "tbody",
        {
          ref_key: "tbodyRef",
          ref: C
        },
        [
          (v(!0), D(
            Y,
            null,
            M(R.value, (r, l) => (v(), D("tr", { key: l }, [
              (v(!0), D(
                Y,
                null,
                M(r, (n, o) => (v(), D("td", {
                  key: `${l}_${o}`,
                  ref_for: !0,
                  ref: (c) => n.isSelected && (x.value = c),
                  class: V(["available", F(n)]),
                  "aria-selected": n.isSelected,
                  "aria-label": String(n.text),
                  tabindex: n.isSelected ? 0 : -1,
                  onKeydown: [
                    N(A(_, ["prevent", "stop"]), ["space"]),
                    N(A(_, ["prevent", "stop"]), ["enter"])
                  ]
                }, [
                  W(w(ee), { cell: n }, null, 8, ["cell"])
                ], 42, ne))),
                128
                /* KEYED_FRAGMENT */
              ))
            ]))),
            128
            /* KEYED_FRAGMENT */
          ))
        ],
        512
        /* NEED_PATCH */
      )
    ], 42, se));
  }
});
export {
  De as default
};
